module.exports = __webpack_public_path__ + "media/dashboard/assets/crm/house-42a8a1b8ec9be9cc33ed0964f976f171.svg";